var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"avatars-w-50"},[_c('app-avatar',{attrs:{"title":_vm.rowData.name,"img":_vm.rowData.file ? _vm.rowData.file.full_url : _vm.urlGenerator('images/default-image.jpg'),"alt-text":_vm.rowData.name,"shadow":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }